import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetParentClientsByConfigQuery } from '../coachingInsight/coachingInsightFeedback/agentFilter/agentFilterSlice';
import {
    useGetOneUpTeamleadsPcQuery,
    useGetTwoUpManagersPcQuery,
} from '../../features/coaching/coachingSlice';
import {
    selectCurrentEmpid,
    selectCurrentMgrEmpid,
    selectCurrentUserManagerLevel,
} from '../../pages/login/authSlice';
import { ROLES } from '../../constants';

interface UserHierarchyFiltersProps {
    userParentClient?: any[];
    setSelectedTL: React.Dispatch<any>;
}

export const UserHierarchyFilters = ({ userParentClient, setSelectedTL }: UserHierarchyFiltersProps) => {
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedMgrEmpNum = useSelector(selectCurrentMgrEmpid);
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);

    const [selectedTLList, setSelectedTLList] = useState<any>([]);
    const [selectedTeamLead, setSelectedTeamLead] = useState<any>();
    const [selectedParentClient, setSelectedParentClient] = useState<any[]>();
    const [selectedMngr, setSelectedMngr] = useState('');
    const [managersList, setManagersList] = useState([]);

    const { data: allParentClientsData, isFetching: allParentClientsDataFetching } =
        useGetParentClientsByConfigQuery({
            // configCode: COACHING_INSIGHTS_CONFIG,
        });
    const { data: managersData, isFetching: allManagersDataFetching } = useGetTwoUpManagersPcQuery(
        {
            parentClientIds: selectedParentClient,
        },
        {
            skip: !selectedParentClient || selectedParentClient.length <= 0,
        }
    );
    const { data: directReportees, isFetching: allDirectReporteesFetching } = useGetOneUpTeamleadsPcQuery(
        {
            managerNumber: parseInt(selectedMngr, 10),
            parentClientIds: selectedParentClient,
        },
        {
            skip: !selectedMngr || !selectedParentClient || selectedParentClient.length <= 0,
        }
    );

    const onParentClientChange = (e: any) => {
        setSelectedParentClient(e.value);
        setSelectedMngr('');
        if (selectedParentClient && selectedParentClient.length > 0) {
            setSelectedMngr('');
            setManagersList([]);
        }
    };

    useEffect(() => {
        if (directReportees?.data?.length > 0) {
            setSelectedTLList(directReportees);
        }
    }, [directReportees]);

    useEffect(() => {
        if (userParentClient && userParentClient.length > 0) {
            const isIdInList = allParentClientsData?.data?.some(
                (pc: any) => pc.parent_client_id === userParentClient?.[0]
            );
            setSelectedParentClient(isIdInList ? userParentClient : []);
        } else setSelectedParentClient([]);
    }, [userParentClient, allParentClientsData]);

    useEffect(() => {
        if (managersData?.data.length > 0) {
            setManagersList(managersData?.data);
        }
    }, [managersData]);

    useEffect(() => {
        if (!selectedTLList?.data?.length) {
            return;
        }

        const findTL = (empNum: string) =>
            selectedTLList.data.some((tl: any) => tl?.employee_number === empNum);

        if (selectedMngr === loggedMgrEmpNum && findTL(loggedEmpNum)) {
            setSelectedTeamLead(loggedEmpNum);
            setSelectedTL(loggedEmpNum);
        }
    }, [selectedTLList]);

    useEffect(() => {
        if (!managersList?.length || !ROLES.Supervisor2AndAbove.includes(userManagerLevel)) {
            return;
        }

        const findManager = (empNum: string) =>
            managersList.some((manager: any) => manager?.employee_number === empNum);

        if (findManager(loggedEmpNum)) {
            setSelectedMngr(loggedEmpNum);
        } else if (findManager(loggedMgrEmpNum)) {
            setSelectedMngr(loggedMgrEmpNum);
        }
    }, [managersList]);

    return (
        <div className="custom-filter-container">
            <div className="filter-box">
                <label htmlFor="parentClient">Parent Client</label>
                <MultiSelect
                    id="parentClient"
                    // placeholder={
                    //     allParentClientsData?.data?.length > 0 ? 'Select Parent Client' : 'Loading...'
                    // }
                    placeholder={allParentClientsDataFetching ? 'Loading...' : 'Select Parent Client'}
                    options={allParentClientsData?.data}
                    optionValue={'parent_client_id'}
                    optionLabel={'parent_client_name'}
                    value={selectedParentClient}
                    onChange={onParentClientChange}
                    maxSelectedLabels={3}
                    className="w-full md:w-20rem custom-dropdown"
                    disabled={ROLES.SupervisorOrOnlyManager.includes(userManagerLevel)}
                />
            </div>

            <div className="filter-box">
                <label htmlFor="select-mngr">Select Manager</label>
                <Dropdown
                    id="select-mngr"
                    // placeholder={managersList.length > 0 ? 'Select Manager' : 'Loading...'}
                    placeholder={allManagersDataFetching ? 'Loading...' : 'Select Manager'}
                    className="w-full md:w-20rem custom-dropdown"
                    options={managersList}
                    optionValue={'employee_number'}
                    optionLabel={'employee_name'}
                    value={selectedMngr}
                    onChange={(e) => {
                        setSelectedMngr(e.target.value);
                    }}
                    filter
                    disabled={ROLES.Supervisor.includes(userManagerLevel)}
                />
            </div>

            <div className="filter-box">
                <label className="filter-label" htmlFor="TLSelection">
                    Select Team Lead
                </label>
                <Dropdown
                    value={selectedTeamLead}
                    onChange={(event) => {
                        setSelectedTeamLead(event.target.value);
                        setSelectedTL(event.target.value);
                    }}
                    options={selectedTLList?.data || []}
                    optionLabel={'employee_name'}
                    optionValue={'employee_number'}
                    placeholder={allDirectReporteesFetching ? 'Loading...' : 'Select Team Lead'}
                    className="w-full md:w-20rem custom-dropdown"
                    filter
                />
            </div>
        </div>
    );
};
